import React from 'react'

import clsx from 'clsx'

import InteractiveElement from '$extensionSrc/components/InteractiveElement'
import { getPlatformName } from '$extensionSrc/data/platform/name'
import { PLATFORM } from '$extensionSrc/utils/enums'
import { getLogoFromPlatform } from '$extensionSrc/utils/platformMetadataUtils'

import styles from './PlatformRow.module.scss'

const highlightedFeatureTypeMap: Record<PLATFORM, 'tool' | 'setting' | null> = {
  [PLATFORM.BLUESKY]: 'tool',
  [PLATFORM.FACEBOOK]: 'tool',
  [PLATFORM.GOOGLE]: 'setting',
  [PLATFORM.INSTAGRAM]: 'setting',
  [PLATFORM.LINKEDIN]: 'setting',
  [PLATFORM.REDDIT]: 'setting',
  [PLATFORM.SNAPCHAT]: null, // Snapchat only has manual recs. Do not offer trial.
  [PLATFORM.STRAVA]: 'setting',
  [PLATFORM.TIKTOK]: null, // TikTok only has manual recs. Do not offer trial.
  [PLATFORM.TWITTER]: 'tool',
  [PLATFORM.VENMO]: 'setting',
  [PLATFORM.YOUTUBE]: 'setting',
}

const highlightedFeatureNameMap: Record<PLATFORM, string | null> = {
  [PLATFORM.BLUESKY]: 'Delete your posts',
  [PLATFORM.FACEBOOK]: 'Mass unfriend profiles',
  [PLATFORM.GOOGLE]: 'Keep your profile info private',
  [PLATFORM.INSTAGRAM]: 'Limit tagged photos',
  [PLATFORM.LINKEDIN]: 'Opt out of generative AI model training',
  [PLATFORM.REDDIT]: 'Limit visibility on Reddit',
  [PLATFORM.SNAPCHAT]: null, // Snapchat only has manual recs. No highlighted feature.
  [PLATFORM.STRAVA]: 'Prevent precise location tracking',
  [PLATFORM.TIKTOK]: null, // TikTok only has manual recs. No highlighted feature.
  [PLATFORM.TWITTER]: "Block a post's reposters",
  [PLATFORM.VENMO]: 'Make sure your payments are private',
  [PLATFORM.YOUTUBE]: 'Limit who can see your subscriptions',
}

export default function PlatformRow({
  platform,
  checked,
  onClick,
  showCheckbox,
}: {
  platform: PLATFORM
  checked: boolean | undefined
  onClick: () => void | undefined
  showCheckbox: boolean
}) {
  return (
    <InteractiveElement
      aria-label={`Select ${getPlatformName(platform)} for your trial`}
      className={clsx(
        styles.platformRow,
        platform === PLATFORM.YOUTUBE && styles.youtube,
        showCheckbox && styles.showInput,
        checked && styles.checked,
      )}
      onClick={onClick}
      tabIndex={showCheckbox ? 0 : -1}
    >
      <div className={styles.inputSection}>
        {showCheckbox && (
          <>
            <div
              className={clsx(styles.radioInput, checked && styles.checked)}
            />
            <div className={styles.platformName}>
              {getLogoFromPlatform(platform, styles.icon)}
              <div className={styles.label}>{getPlatformName(platform)}</div>
            </div>
          </>
        )}
        {!showCheckbox && (
          <>
            {getLogoFromPlatform(platform, styles.icon)}
            <div className={styles.label}>{getPlatformName(platform)}</div>
          </>
        )}
      </div>
      <div className={styles.description}>
        <div className="purple">
          {highlightedFeatureTypeMap[platform] === 'tool' &&
            'Most popular tool:'}
          {highlightedFeatureTypeMap[platform] === 'setting' &&
            'Most popular automation:'}
        </div>
        <div>{highlightedFeatureNameMap[platform]}</div>
      </div>
    </InteractiveElement>
  )
}
